export enum RoleEnum {
    "admin" = 1,
    "client" = 2,
    "internationl_client" = 3,
    "professional" = 4,
    "internationl_professional" = 5,
    "emergency_professional" = 6,
}